/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import CIcon from '@coreui/icons-react';

const CustomSelectInput = ({
  icon,
  id,
  name,
  isRequired,
  disabled,
  className,
  options,
  title,
  onChange,
  message,
  label,
  value,
  disableOption,
  onClick,
  width,
  optionsList,
  showDisabled = false,
  hide = false, // ✅ ADD THIS
}) => {
  const selectRef = useRef(null);
  if (hide) return null;

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent bubbling
    if (onClick) onClick(e);
  };

  const handleMouseDown = (e) => {
    e.stopPropagation(); // Prevent mousedown from bubbling
  };

  return (
    <div className={`form-outline text-start ${icon ? 'mt-2' : width ? width : 'w-75'}`}>
      {label && (
        <label htmlFor={id} className="login_label labelName mb-2">
          {label}
        </label>
      )}
      <div className="form-outline text-start">
        <div className={`position-relative ${icon ? 'input-group' : ''}`}>
          {icon && (
            <span className="input-group-addon" title={title || label || ''}>
              <CIcon
                className={isRequired ? 'mandatory-control' : 'stock-toggle-icon '}
                icon={icon}
              />
            </span>
          )}
          <select
            ref={selectRef}
            id={id}
            className={`form-control position-relative custom-select ${
              disabled ? 'text-dim ' : ''
            } ${className}`}
            onChange={(e) => onChange(e)}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            name={name}
            required={isRequired}
            value={value}
            disabled={disabled}
          >
            {!showDisabled && (
              <option className="text-dim" value="">
                {disableOption ? disableOption : `Select ${label}`}
              </option>
            )}
            {Array.isArray(options) &&
              options.map((option, index) => (
                <React.Fragment key={option.id || index}>
                  {index !== 0 && <optgroup className="option-border" />}
                  <option
                    value={option.id ? option.id : index}
                    className={`${
                      name === 'publishShifts' ? (option.id <= value ? 'bg-success' : '') : ''
                    }`}
                  >
                    {optionsList
                      ? optionsList(option)
                      : name === 'productName'
                      ? `${option.name}, ${option.shortCode}`
                      : name === 'dispatchAssign' ||
                        name === 'driverName' ||
                        name === 'assistantDriver' ||
                        name === 'associate' ||
                        name === 'createdBy'
                      ? `${option.firstName} ${option.lastName}`
                      : option.name}
                  </option>
                </React.Fragment>
              ))}
          </select>
          {isRequired && <span className="invalid-tooltip">{message}</span>}
        </div>
      </div>
    </div>
  );
};

export default CustomSelectInput;
